const initials = "login";

export const ON_LOGIN = `${initials}ON_LOGIN`;
export const UPDATE_LOGIN_DETAILS = `${initials}ON_LOGIN_COMPLETE`;